import addFormats from "ajv-formats";
import { customizeValidator } from "@rjsf/validator-ajv8";
import ajvErrors from "ajv-errors";
import {isValidGTIN, UrlValidator} from "../utils/common";

// Singleton instance
let customizedAjvInstance = null;

function createCustomAjvValidator() {
  if (customizedAjvInstance) {
    return customizedAjvInstance;
  }

  customizedAjvInstance = customizeValidator({
    ajvOptionsOverrides: {
      allErrors: true,
    }
  });

  if (!customizedAjvInstance.ajv.getKeyword("formatMaximum")) {
    addFormats(customizedAjvInstance.ajv);
  }
  ajvErrors(customizedAjvInstance.ajv);

  customizedAjvInstance.ajv.addFormat("color", {
    type: "string",
    validate: (data) => {
      const hexColorRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
      return hexColorRegex.test(data);
    },
  });

  // Reuse shared validation logic from common.js (UrlValidator)
  customizedAjvInstance.ajv.addFormat("landing-url", {
    type: "string",
    validate: (data) => UrlValidator(data).valid,
  });

  customizedAjvInstance.ajv.addVocabulary(["enumNames"]);

  customizedAjvInstance.ajv.addKeyword({
    keyword: "gtinChecksum",
    validate: (schema, data) => schema ? isValidGTIN(data) : true,
    errors: true,
    metaSchema: { type: "boolean" }
  });

  return customizedAjvInstance;
}

export {
  createCustomAjvValidator,
};
